// controllers/dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    // Bind the function so that you can properly remove the event listener later.
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  handleClickOutside(event) {
    this.dropdownTargets.forEach((dropdown) => {
      // Check if the clicked element is outside of the current dropdown
      if (!dropdown.contains(event.target)) {
        // If so, remove the "open" attribute to close the dropdown
        dropdown.removeAttribute("open")
      }
    })
  }
}
